import { documentToReactComponents, Options } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import { options } from '@/services/ContentfulService'

/** Minimal shape for Contentful rich text links (assets.block) used to resolve embedded assets */
export interface RichTextLinksAssetBlock {
  __typename?: string
  sys: { id: string }
  url?: string | null
  title?: string | null
  width?: number | null
  height?: number | null
  description?: string | null
}

export interface RichTextLinks {
  assets?: {
    block?: Array<RichTextLinksAssetBlock | null>
  }
}

interface ContentfulRichTextProps {
  className?: string
  json?: Document
  links?: RichTextLinks
  renderOptionOverrides?: (options: Options, links?: RichTextLinks) => Options
}

export const ContentfulRichText: React.FC<ContentfulRichTextProps> = ({
  className,
  json,
  links,
  renderOptionOverrides = (opts) => opts,
}) => {
  if (!json) return null

  return <div className={className}>{documentToReactComponents(json, renderOptionOverrides(options, links))}</div>
}
